export const PRIMARY_COMPONENT_SLOTS = Object.freeze({
  motherboard: 'motherboard',
  gpu: 'gpu',
  psu: 'psu',
  aircooler: 'cooling',
  radiator: 'cooling'
});

export function componentSlotForTrackType(trackType) {
  return PRIMARY_COMPONENT_SLOTS[String(trackType || '').toLowerCase()] || null;
}

export function isPrimarySimulatorComponent(comp) {
  return !!(comp?.isComponent && componentSlotForTrackType(comp.trackType));
}

export function primaryComponentsBySlot(activeBoxes = []) {
  const bySlot = new Map();
  for (const comp of activeBoxes) {
    if (!isPrimarySimulatorComponent(comp)) continue;
    const slot = componentSlotForTrackType(comp.trackType);
    // Last selected/created component wins deterministically. This protects the
    // solver against stale duplicates from older Workbench sessions.
    bySlot.set(slot, comp);
  }
  return bySlot;
}

export function primaryComponentList(activeBoxes = []) {
  const bySlot = primaryComponentsBySlot(activeBoxes);
  return ['motherboard', 'gpu', 'psu', 'cooling']
    .map(slot => bySlot.get(slot))
    .filter(Boolean);
}

export function componentsInSameSlot(activeBoxes = [], trackType, excludeUid = null) {
  const slot = componentSlotForTrackType(trackType);
  if (!slot) return [];
  return activeBoxes.filter(comp =>
    comp?.isComponent &&
    comp.uid !== excludeUid &&
    componentSlotForTrackType(comp.trackType) === slot
  );
}

export function resetComponentSpatialOverrides(comp, { resetCoolerRotation = true } = {}) {
  if (!comp?.isComponent) return comp;

  comp.preferredSnapId = null;
  comp.preferredOrientationClass = null;
  comp.preferredOrientationTopology = null;
  comp.activeSnapId = null;
  comp.activeSnapSource = null;

  // Cooler offsets are relative to a specific motherboard/case solve and must
  // never leak into the next case. General component slider coordinates are
  // absolute scene positions and are overwritten by the next solver snap.
  comp.userOffsetX = 0;
  comp.userOffsetY = 0;
  comp.userOffsetZ = 0;

  if (resetCoolerRotation && (comp.trackType === 'aircooler' || comp.isAirCooler)) {
    comp.socketQuarterTurn = 0;
  }

  comp.relationalOrientationSource = 'constraint_solver_pending';
  comp.relationalOrientationTrainingTier = 'weak_layout_prior';
  comp.orientationProfileLabel = null;
  comp.attachedToMoboUid = null;
  return comp;
}
